export default __webpack_public_path__ + "static/sunilWadhwa-80f66a33ac34af37ece9ccc918b7fe20.jpg";